import type { TranslationMap } from '../i18n';

export const nb: TranslationMap = {
  // Auth - Common
  'auth.email': 'E-post',
  'auth.password': 'Passord',
  'auth.firstName': 'Fornavn',
  'auth.lastName': 'Etternavn',
  'auth.back': '← Tilbake',
  'auth.acceptTerms': 'Jeg godtar',
  'auth.termsAndConditions': 'Vilkår og betingelser',
  'auth.verificationRequired': 'Verifisering kreves',
  'auth.verificationLinkSent': 'Klikk på bekreftelseslenken i innboksen din.',
  'auth.sending': 'Sender...',
  'auth.resendLink': 'Send lenken igjen',
  'auth.phonePlaceholder': 'xxx xx xxx',

  // Auth - Login
  'auth.signIn': 'Logg inn',
  'auth.signingIn': 'Logger inn...',
  'auth.resetPassword': 'Tilbakestill passord',
  'auth.createAccount': 'Opprett konto',
  'auth.logIn': 'Logg inn',
  'auth.logInToPurchase': 'Logg inn for å kjøpe',

  // Auth - Account Create
  'auth.zipcodeOptional': 'Postnummer (valgfritt)',
  'auth.zipcodePlaceholder': 'Postnummer',
  'auth.phoneNumberOptional': 'Telefonnummer (valgfritt)',
  'auth.phoneNumber': 'Telefonnummer',
  'auth.birthdayOptional': 'Fødselsdato (valgfritt)',
  'auth.birthday': 'Fødselsdato',
  'auth.subscribeToMarketing': 'Abonner på e-postmarkedsføring',
  'auth.create': 'Opprett',
  'auth.creating': 'Oppretter...',
  'auth.alreadyHaveAccount': 'Har du allerede en konto?',

  // Auth - Reset Password
  'auth.submit': 'Send inn',

  // Auth - Errors
  'auth.errorUnableToSignIn': 'Kan ikke logge inn. Vennligst prøv igjen.',
  'auth.errorLoginGeneric': 'Det oppstod en feil under innlogging. Vennligst prøv igjen.',
  'auth.errorRequiredFields': 'Obligatoriske felt mangler. Vennligst fyll ut skjemaet.',
  'auth.errorCreateGeneric': 'Det oppstod en feil. Vennligst prøv igjen.',
  'auth.errorCreateAccount': 'Det oppstod en feil under oppretting av konto. Vennligst prøv igjen.',
  'auth.errorEmailNotFound': 'E-postfelt ikke funnet. Vennligst prøv igjen.',
  'auth.errorEnterEmail': 'Vennligst oppgi e-postadressen din.',
  'auth.errorResetPassword': 'Kan ikke tilbakestille passord. Vennligst prøv igjen.',
  'auth.errorResetGeneric':
    'Det oppstod en feil under tilbakestilling av passord. Vennligst prøv igjen.',
  'auth.error.login_required': 'Innlogging kreves. Vennligst oppgi e-post og passord.',
  'auth.error.invalid_credentials': 'Ugyldig e-post eller passord. Vennligst prøv igjen.',
  'auth.error.account_already_exists':
    'Det finnes allerede en konto med denne e-posten. Vennligst logg inn.',
  'auth.error.invalid_email':
    'E-postadressen som ble oppgitt er ikke gyldig. Vennligst prøv igjen.',
  'auth.error.weak_password': 'Passordet ditt er for svakt. Vennligst velg et sterkere passord.',
  'auth.error.missing_fields': 'Alle felt er påkrevd. Vennligst fyll ut skjemaet.',
  'auth.error.invalid_name': 'Navnet som ble oppgitt er ikke gyldig. Vennligst bruk kun bokstaver.',
  'auth.error.password_mismatch': 'Passordene stemmer ikke overens. Vennligst prøv igjen.',
  'auth.error.missing_email': 'Vennligst oppgi e-postadressen din.',
  'auth.error.email_not_found':
    'Vi fant ingen konto med denne e-postadressen. Vennligst sjekk og prøv igjen.',
  'auth.error.email_verify': 'Vennligst bekreft e-postadressen din og prøv igjen.',
  'auth.error.captcha_challenge':
    'Ytterligere verifisering kreves. Vennligst fullfør sikkerhetskontrollen.',
  'auth.error.unknown_error': 'En ukjent feil oppstod. Vennligst prøv igjen senere.',

  // Product
  'product.buyNow': 'Kjøp nå',
  'product.soldOut': 'Utsolgt',
  'product.processing': 'Behandler...',
  'product.errorAddToCart': 'Kan ikke legge til i handlekurv.',

  // Need Access
  'access.logInToWatch': 'Logg inn for å se',
  'access.purchaseAccess': 'Kjøp tilgang',
  'access.joinOrPurchase': 'Bli med i fellesskapet eller kjøp tilgang',
  'access.noAccess': 'Du har ikke tilgang til dette innholdet',
  'access.joinToUnlock': 'Bli medlem for å låse opp',
  'access.joinForAccess': 'Bli medlem for tilgang',
  'access.locked': 'Låst',
  'access.joinToWatch': 'Bli med for å se',
  'access.joinOrPurchaseAccess': 'Bli med eller kjøp tilgang',
  'access.alreadyPurchased': 'Allerede kjøpt?',
  'access.logInWithEmail': 'Logg inn med e-posten brukt til kjøpet',
  'access.or': '- eller -',
  'access.noProductsAvailable': 'Ingen produkter som gir tilgang er tilgjengelige for øyeblikket',
  'access.upgradeToAccess': 'Oppgrader for tilgang',

  // Perks
  'perks.posts': 'Innlegg',
  'perks.videos': 'Videoer',
  'perks.merch': 'Merch',
  'perks.codes': 'Koder',
  'perks.music': 'Musikk',
  'perks.recentPosts': 'Nylige innlegg',
  'perks.myAccount': 'Min konto',
  'perks.logout': 'Logg ut',
  'perks.noActiveMemberships': 'Ingen aktive medlemskap.',
  'perks.generating': 'Genererer...',
  'perks.noCodesFound': 'Ingen koder funnet',
  'perks.noProducts': 'Ingen produkter',
  'perks.foundFor': 'funnet for "{query}"',
  'perks.more': 'Mer',
  'perks.join': 'Bli med',
  'perks.collectibles': 'Samleobjekter',
  'perks.popularPosts': 'Populære innlegg',
  'perks.noPosts': 'Ingen innlegg',
  'perks.adjustFilters': 'Prøv å justere filtrene dine eller kom tilbake snart!',
  'perks.loadMorePosts': 'Last inn flere innlegg',
  'perks.loadMore': 'Last inn mer',
  'perks.memberSince': 'Medlem siden',
  'perks.continueReading': 'Fortsett å lese',
  'perks.joinToContinueReading': 'Bli med for å fortsette å lese',
  'perks.beFirstToComment': 'Vær den første til å legge igjen en kommentar!',
  'perks.addComment': 'Legg til en kommentar...',
  'perks.addCommentButton': 'Legg til en kommentar',
  'perks.joinToComment': 'Bli med for å kommentere',
  'perks.commentRemoved': '[ fjernet ]',
  'perks.commentHasBeenRemoved': 'Kommentaren har blitt fjernet.',
  'perks.reply': 'Svar',
  'perks.replyToComment': 'Svar på kommentar...',
  'perks.viewReplies': 'Vis svar',
  'perks.loadMoreReplies': 'Last inn flere svar',
  'perks.replyCount.one': '1 svar',
  'perks.replyCount.other': '{count} svar',
  'perks.filterPosts': 'Filtrer innlegg',
  'perks.postType': 'Innleggstype',
  'perks.postTypeText': 'Tekst',
  'perks.postTypeImages': 'Bilder',
  'perks.postTypeVideos': 'Videoer',
  'perks.postTypeProducts': 'Produkter',
  'perks.postTypeAudio': 'Lyd',
  'a11y.play': 'Spill av',
  'a11y.pause': 'Pause',
  'a11y.seek': 'Fremdrift',
  'a11y.audioArtwork': 'Lydomslag',
  'a11y.trackArtwork': 'Omslag for {title}',
  'a11y.viewArtwork': 'Vis omslag',
  'perks.tags': 'Tags',
  'perks.authors': 'Forfattere',
  'perks.submission.submitPost': 'Send inn et innlegg',
  'perks.submission.createPost': 'Opprett et innlegg',
  'perks.submission.postingAs': 'Publiserer som',
  'perks.submission.loginRequired': 'Logg inn på kontoen din for å dele et innlegg.',
  'perks.submission.titleLabel': 'Tittel',
  'perks.submission.titlePlaceholder': 'Gi innlegget ditt en tittel',
  'perks.submission.captionLabel': 'Bildetekst',
  'perks.submission.captionPlaceholder': 'Legg til en bildetekst',
  'perks.submission.addImage': 'Legg til et bilde',
  'perks.submission.changeImage': 'Bytt bilde',
  'perks.submission.uploading': 'Laster opp...',
  'perks.submission.submit': 'Send inn til gjennomgang',
  'perks.submission.submitting': 'Sender inn...',
  'perks.submission.post': 'Publiser',
  'perks.submission.posting': 'Publiserer...',
  'perks.submission.postAnother': 'Publiser et nytt',
  'perks.submission.success': 'Sendt inn! Innlegget ditt venter på gjennomgang.',
  'perks.submission.successPublished': 'Innlegget ditt er publisert.',
  'perks.submission.submitAnother': 'Send inn et nytt',
  'perks.submission.invalidImageType': 'Vennligst velg et JPG-, PNG- eller GIF-bilde.',
  'perks.submission.invalidImageSize': 'Bilder må være mindre enn 25 MB.',
  'perks.submission.errorUploadImage':
    'Noe gikk galt under opplasting av bildet ditt. Vennligst prøv igjen.',
  'perks.submission.errorSubmit':
    'Noe gikk galt under innsending av innlegget ditt. Vennligst prøv igjen.',
  'perks.submission.errorLimit': 'Innsendingsgrensen er nådd. Prøv igjen i morgen.',
  'perks.submission.errorUsername': 'Brukernavnet er ikke tilgjengelig for innsendinger',
  'perks.submission.removeImage': 'Fjern bilde',
  'perks.badge.artist': 'Verifisert',
  'perks.badge.team': 'Team',
  'perks.shadowBanned': 'Skyggeutestengt: bare denne fanen og moderatorer ser dette. Opphev det i Single-dashbordet under Innlegg > Innstillinger.',
  'perks.artistProfileManaged': 'Artistprofilen din administreres i Single-dashbordet',
  'perks.clearAll': 'Tøm alle',
  'perks.applyFilters': 'Bruk filtre',
  'perks.backToFeed': '← Tilbake til feed',
  'perks.backToLibrary': '← Tilbake til biblioteket',
  'music.album': 'Album',
  'music.download': 'Last ned',
  'music.loginToDownload': 'Logg inn for å laste ned',
  'music.linkExpired': 'Denne lenken har utløpt.',
  'music.loginToAccess':
    'Logg inn med e-posten som ble oppgitt ved kjøp for å lytte eller laste ned.',
  'perks.noVideos': 'Ingen videoer',
  'perks.noMusic': 'Ingen musikk',
  'perks.gridView': 'Rutenettvisning',
  'perks.listView': 'Listevisning',
  'perks.oops': 'Oops!',
  'perks.notFound': '404: Not Found',
  'perks.goBack': 'Gå tilbake',
  'perks.account': 'Konto',
  'perks.displayName': 'Visningsnavn',
  'perks.emailPreferences': 'E-postinnstillinger',
  'perks.emailPreference.POST_NOTIFICATIONS': 'Nye innlegg',
  'perks.emailPreference.POST_NOTIFICATIONS.description':
    'Få en e-post når et nytt innlegg publiseres.',
  'perks.emailPreference.COMMENT_NOTIFICATIONS': 'Kommentarer og svar',
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description':
    'Få en e-post når noen svarer på kommentaren din.',
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description.submissions':
    'Få en e-post når noen svarer på kommentaren din eller kommenterer et innlegg du har sendt inn.',
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description.author':
    'Få en e-post når noen svarer på kommentaren din eller kommenterer et innlegg du har publisert.',
  'perks.comments': 'Kommentarer',
  'perks.view': 'Se',
  'perks.transfer': 'Overfør',
  'perks.logInToViewCollectibles': 'Logg inn for å se samleobjekter',
  'perks.viewAll': 'Se alle',
  'perks.errorUploadAvatar': 'Kan ikke laste opp avatar. Vennligst prøv igjen.',
  'perks.profileCardTitle': 'Velkommen! La oss fullføre medlemsprofilen din.',
  'perks.walletCardTitle': 'Last ned medlemskortet ditt',
  'perks.walletPassDescription':
    'Ditt medlemspass er et digitalt klubbkort for Apple- eller Android-enheten din. Det vil bli brukt til å gi deg spesielle fordeler på shows og IRL.',
  'perks.walletScanDescription': 'Skann QR-koden med telefonen din for å laste ned passet ditt.',
  'perks.updatingProfile': 'Oppdaterer...',
  'perks.updateProfile': 'Oppdater profil',
  'perks.displayNamePlaceholder': 'Skriv navnet ditt her...',
  'perks.usernamePlaceholder': 'Brukernavn',
  'perks.profileVisibilityNote':
    'Bare avataren og visningsnavnet ditt vil være synlig for andre medlemmer.',
  'perks.trackCount': '{count} spor',
  'perks.trackCountOne': '{count} spor',
  'perks.commentCount': '{count} kommentarer',
  'perks.commentCountOne': '{count} kommentar',
  'perks.replyingTo': 'Svarer @{name}',
  'perks.postCommentButton': 'Publiser',
  'perks.avatarAlt': 'Avatar for {name}',
  'perks.hiddenPostImageAlt': 'Bilde av skjult innlegg',
  'perks.postImageAlt': 'Innleggsbilde',
  'perks.imageSlideAlt': 'Bildeslide',
  'perks.videoThumbnailAlt': 'Videominiatyr',
  'perks.productImageAlt': 'Produkt',
  'perks.membershipImageAlt': 'medlemskapsbilde',
  'perks.tierImageAlt': 'nivåbilde',
  'perks.authorImageAlt': 'forfatterbilde',
  'perks.submission.previewAlt': 'forhåndsvisning av innsending',
  'a11y.countryCode': 'Landskode',
  'a11y.dismiss': 'Avvis',

  // Address Modal
  'address.updateAddress': 'Oppdater adresse',
  'address.firstName': 'Fornavn',
  'address.lastName': 'Etternavn',
  'address.street': 'Gate',
  'address.streetLine2': 'Gatelinje 2',
  'address.city': 'By',
  'address.country': 'Land',
  'address.province': 'Fylke',
  'address.zip': 'Postnummer',
  'address.phoneNumber': 'Telefonnummer',
  'address.update': 'Oppdater',
  'address.updating': 'Oppdaterer...',
  'address.errorStreetRequired': 'Gateadresse er påkrevd',
  'address.errorCountryRequired': 'Land er påkrevd',
  'address.errorZipRequired': 'Postnummer er påkrevd',
  'address.errorPhoneRequired': 'Telefonnummer er påkrevd',

  // Common
  'common.cancel': 'Avbryt',
  'common.ok': 'Ok',
  'common.close': 'Lukk',
  'common.dialog': 'Dialog',
  'a11y.communityNav': 'Fellesskapssider',
  'a11y.likePost': 'Lik innlegg',
  'a11y.unlikePost': 'Fjern liker på innlegg',
  'a11y.viewComments': 'Vis kommentarer',
  'a11y.previousSlide': 'Forrige bilde',
  'a11y.nextSlide': 'Neste bilde',
  'a11y.goToSlide': 'Gå til bilde {number}',
  'a11y.collapseComment': 'Skjul kommentar',
  'a11y.expandComment': 'Utvid kommentar',
  'a11y.commentMenu': 'Kommentaralternativer',
  'a11y.deleteComment': 'Slett kommentar',
  'a11y.likeComment': 'Lik kommentar',
  'a11y.unlikeComment': 'Fjern liker på kommentar',
  'a11y.reply': 'Svar',
  'a11y.closeReplies': 'Lukk svar',
  'a11y.backToFeed': 'Tilbake til feeden',
  'a11y.uploadAvatar': 'Last opp avatar',
  'common.searchByTitle': 'Søk etter tittel',
  'common.search': 'Søk',
  'common.clear': 'Tøm',
  'common.error': 'Feil',
  'common.save': 'Lagre',
  'common.saving': 'Lagrer...',
  'common.edit': 'Rediger',
  'common.delete': 'Slett',
  'common.loading': 'Laster...',
  'common.uploading': 'Laster opp...',
  'common.readMore': 'les mer',
  'common.readLess': 'les mindre',
  'common.share': 'Del',
  'common.copied': 'Kopiert!',
  'common.browserShareError': 'Nettleseren din støtter ikke deling eller utklippstavle.',
  'common.alreadyMember': 'Allerede medlem?',

  // Membership
  'membership.confirm': 'Bekreft',
  'membership.nevermind': 'Glem det',
  'membership.noGoBack': 'Nei, Gå tilbake',
  'membership.yesCancel': 'Ja, Avbryt',
  'membership.goBack': 'Gå tilbake',
  'membership.continue': 'Fortsett',
  'membership.confirmChange': 'Bekreft endring',
  'membership.termsAndConditions': 'Vilkår og betingelser',
  'membership.updateBillingTerms': 'Oppdater betalingsbetingelsene dine',
  'membership.confirmYourChanges': 'Bekreft endringene dine',
  'membership.confirmUpgrade': 'Bekreft oppgradering',
  'membership.confirmDowngrade': 'Bekreft nedgradering',
  'membership.termChange': 'Termskifte',
  'membership.labelCancellation': '{label} avbestilling',
  'membership.cancelPendingTitle': 'Avbryt {change}',
  'membership.yesCancelPending': 'Ja, avbryt {change}',
  'membership.revertSettings': 'Din {label} vil gå tilbake til de forrige innstillingene.',
  'membership.cancelTitle': 'Avbryt {label}',
  'membership.areYouSureCancel': 'Er du sikker på at du vil avbryte?',
  'membership.cancellationEndOfTerm':
    'Avbestillingen din trer i kraft ved slutten av perioden din.',
  'membership.stillHaveAccess':
    'Du vil imidlertid fortsatt ha tilgang til ditt betalte {label} for resten av perioden din.',
  'membership.expirationDate': '{label} utløpsdato:',
  'membership.notice': 'Merknad:',
  'membership.cancellationNotice':
    '{label}-avbestillinger trer ikke i kraft før slutten av perioden din.',
  'membership.contactForQuestions': 'For spørsmål om avbestilling av {label}, vennligst kontakt',
  'membership.contactIfUnsure':
    'Hvis du er usikker på om dette gjelder din spesifikke bestilling, vennligst kontakt kundeservice.',
  'membership.cancelMembershipButton': 'Avbryt medlemskap',
  'membership.currentPlan': 'Nåværende plan',
  'membership.newPlan': 'Ny plan',
  'membership.newPlanStarts': 'Din nye plan starter',
  'membership.newTierTerm': 'Ny nivåperiode:',
  'membership.nextBillingDateLabel': 'Neste faktureringsdato:',
  'membership.perMonth': '/Måned',
  'membership.aboutToUpgrade': 'Du er i ferd med å oppgradere medlemskapsnivået ditt.',
  'membership.aboutToDowngrade': 'Du er i ferd med å nedgradere medlemskapsnivået ditt.',
  'membership.viewMyPerks': 'Se mine fordeler',
  'membership.manage': 'Administrer',
  'membership.joining': 'Blir med...',
  'membership.join': 'Bli med',
  'membership.addingToCart': 'Legger til i handlekurv...',
  'membership.upgrade': 'Oppgrader',
  'membership.downgrade': 'Nedgrader',
  'membership.cancelPendingChanges': 'Avbryt ventende endringer',
  'membership.active': 'Aktiv',
  'membership.nextBillingDate': 'Neste fakturering',
  'membership.term': 'Periode',
  'membership.changeTerm': '(endre)',
  'membership.price': 'Pris',
  'membership.free': 'GRATIS',
  'membership.per': 'per',
  'membership.oneTimePurchase': 'Engangskjøp',
  'membership.noMembershipsAvailable': 'Ingen medlemskap tilgjengelig',
  'membership.transactionFailed': '{label}-transaksjon mislyktes - Klikk for å oppdatere',
  'membership.noActiveMemberships': 'Ingen aktive medlemskap',
  'membership.pending': 'Ventende',
  'membership.cancellation': 'Avbestilling',
  'membership.upgradeDowngrade': 'Oppgrader / Nedgrader',
  'membership.cancelLink': 'Avbryt',
  'membership.nextShipment': 'Neste forsendelse •',
  'membership.viewProduct': 'Se produkt',
  'membership.hasBeenScheduled': 'har blitt planlagt.',
  'membership.changingTo': 'Endres til:',
  'membership.willBeDowngradedTo': 'Din {label} vil bli nedgradert til',
  'membership.on': 'den',
  'membership.stillHaveAccessUntil': 'Du vil fortsatt ha tilgang til',
  'membership.cancelChange': 'Avbryt endring',
  'membership.nextBilling': 'Neste fakturering',
  'membership.subscriptionShipMonthly': 'Abonnementsbestillinger sendes månedlig.',
  'membership.noUpcomingBillDates': 'Ingen kommende fakturadatoer.',
  'membership.orderHistory': 'Ordrehistorikk',
  'membership.emailWithTracking':
    'Du vil motta en e-post med sporing når bestillingen din er sendt.',
  'membership.back': '← Tilbake',
  'membership.shippingAddress': 'Leveringsadresse',
  'membership.missingAddress': 'Mangler adresseinformasjon. Klikk for å oppdatere.',
  'membership.editShippingAddress': 'Rediger leveringsadresse',
  'membership.paymentMethod': 'Betalingsmetode',
  'membership.updatePaymentInstructions':
    'For å oppdatere betalingsmetoden din, bruk lenken nedenfor. En e-post med instruksjoner vil bli sendt til deg.',
  'membership.updatePaymentMethod': 'Oppdater betalingsmetode',
  'membership.paymentFailed': 'Betaling mislyktes',
  'membership.productImageAlt': 'produktbilde',
  'membership.detailMembership': 'Medlemskap',
  'membership.detailBilling': 'Fakturering',
  'membership.detailPlan': 'Plan',
  'membership.detailMemberId': 'Medlems-ID',
  'membership.detailSubscriptionNumber': 'Abonnement nr.',
  'membership.detailStatus': 'Status',
  'membership.detailTerms': 'Vilkår',
  'membership.detailLastPayment': 'Siste betaling',
  'membership.receivedOn': 'Mottatt {date}',
  'membership.receivedAmountOn': '{amount} mottatt {date}',
  'membership.detailName': 'Navn',
  'membership.detailStreet': 'Gate',
  'membership.detailCity': 'By',
  'membership.detailState': 'Fylke/delstat',
  'membership.detailZip': 'Postnummer',
  'membership.detailCountry': 'Land',
  'membership.detailPhone': 'Telefon',
  'membership.detailCard': 'Kort',
  'membership.detailNumber': 'Nummer',
  'membership.detailExpires': 'Utløper',
  'membership.detailMethod': 'Metode',
  'membership.manageLabel': 'Administrer {label}',

  // Music
  'music.exclusive': 'Eksklusiv',
  'music.trackTitle': 'Tittel',
  'music.songCount': '{count} sanger',
  'music.songCountOne': '{count} sang',
  'music.allTracksAvailableIn': 'ALLE SPOR TILGJENGELIGE OM:',
  'music.preorderUnlock': 'Forhåndsbestill nå og få tilgang til å streame eller laste ned {date}.',
  'music.downloadUnavailable': 'Nedlasting ikke tilgjengelig',
  'music.downloadLimitReached': 'Du har nådd nedlastingsgrensen. Vennligst kontakt butikken.',
  'music.downloadFailed': 'Nedlastingen mislyktes. Vennligst prøv igjen.',
  'music.downloadNotAllowed': 'Logg inn med e-posten du brukte ved kjøpet.',
  'music.downloadCodeUnavailable': 'Denne nedlastingen er ikke tilgjengelig. Vennligst kontakt butikken.',
  'music.downloadStarted': 'Nedlasting startet',
  'music.downloadStartedHint': 'Sjekk nedlastingene dine eller Filer-appen.',
  'music.openInBrowserTitle': 'Nedlasting blokkert',
  'music.openInBrowserBody':
    'Nettleseren i appen du bruker blokkerer nedlastinger. Du må åpne denne siden i en ekstern nettleser.',
  'music.openInBrowserHint':
    'Trykk på •••-ikonet og velg «Åpne i ekstern nettleser» for å fortsette.',
  'music.demoArtist': 'Testartist',
  'music.demoAlbum': 'Demoalbum',
  'music.demoTrack': 'Spor {n}',
  'a11y.previousTrack': 'Forrige spor',
  'a11y.nextTrack': 'Neste spor',
  'a11y.playAll': 'Spill av alle',

  // Video
  'video.startsIn': 'Starter om:',
  'video.previewTitle': 'Videotittel',
  'video.previewArtist': 'Artistnavn',
  'video.previewDescription': 'Videobeskrivelse',
};
